import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { copiarAlPortapapeles } from './comercialUtiles'

const DURACION = 1800        // ms the confirmation stays

// An email or a phone that copies itself to the clipboard on click (no mailto:
// nor tel:), with a small passing confirmation just above it -- or an error,
// never a false "copied". The click (and Enter) stops there, so a list row under
// it doesn't open its card. The confirmation floats over everything (a portal),
// so a table's scroll never clips it.
//   tipo: 'correo' | 'telefono' -- what the hint and the confirmation say
export default function ComercialCopiable({ valor, tipo = 'correo', className = '' }) {
  const { t } = useTranslation('comercial')
  const [aviso, setAviso] = useState(null)        // { ok, left, top }
  const ref = useRef(null)
  const reloj = useRef(null)
  useEffect(() => () => clearTimeout(reloj.current), [])

  const copiar = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    const r = ref.current?.getBoundingClientRect()
    const donde = r ? { left: r.left, top: r.top } : { left: 16, top: 16 }
    let ok = true
    try { await copiarAlPortapapeles(valor) } catch { ok = false }
    clearTimeout(reloj.current)
    setAviso({ ok, ...donde })
    reloj.current = setTimeout(() => setAviso(null), DURACION)
  }

  return (
    <>
      <button ref={ref} type="button" onClick={copiar} onKeyDown={e => e.stopPropagation()} title={t(`copia.${tipo}.copiar`)}
        className={`text-left break-all hover:underline cursor-pointer ${className || 'text-gray-700 hover:text-gray-900'}`}>
        {valor}
      </button>
      {aviso && createPortal(
        <span role="status" aria-live="polite"
          style={{ position: 'fixed', left: aviso.left, top: Math.max(4, aviso.top - 28), zIndex: 70 }}
          className={`pointer-events-none rounded-md px-2 py-1 text-xs font-medium shadow-sm ${aviso.ok
            ? 'bg-gray-900 text-white' : 'bg-red-600 text-white'}`}>
          {aviso.ok ? `✓ ${t(`copia.${tipo}.copiado`)}` : t(`copia.${tipo}.noCopiado`)}
        </span>, document.body)}
    </>
  )
}
